// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import {
  renderPriceSection,
  renderRatings,
} from '@tcp/core/src/components/common/molecules/RecommendationCarousel/views/RecommendationTile.view';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';
import { getVideoUrl, getDynamicBadgeQty } from '@tcp/core/src/utils/utils';
import {
  IMG_DATA_PLP,
  VID_DATA_SLP,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/config';
import ImageComponent from '@tcp/core/src/components/features/browse/BundleProduct/atoms/Image';
import { getProductListToPath } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import styles, { ImageContainer } from '../styles/TrendingInCategoryTile.style';

const renderImage = ({
  imageUrl,
  dynamicBadgeOverlayQty,
  pdpAsPath,
  pdpToPath,
  name,
  tcpStyleType,
  primaryBrand,
  isTrendingInCategoryRecommendationsDisplayBadgeEnabled,
}) => {
  const isVideoUrl = imageUrl && getVideoUrl(imageUrl);
  const mainConfig = isVideoUrl ? VID_DATA_SLP.imgConfig : IMG_DATA_PLP.imgConfig;

  return (
    <ImageContainer>
      <ImageComponent
        pdpAsPath={pdpAsPath}
        pdpToPath={pdpToPath}
        dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
        mainConfig={mainConfig}
        isVideoUrl={isVideoUrl}
        imageData={{ alt: name, url: imageUrl }}
        TCPStyleType={tcpStyleType}
        badgeConfig={IMG_DATA_PLP.badgeConfig}
        primaryBrand={primaryBrand}
        lazyLoadImage
      />
      {isTrendingInCategoryRecommendationsDisplayBadgeEnabled && (
        <div className="overlay-badge">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34"
            height="47"
            viewBox="0 0 34 47"
            fill="none"
            className="svg-background desktop"
          >
            <path
              d="M0 0H33.9444V47L1.69589 42.0387C0.720226 41.8886 0 41.0491 0 40.0619V0Z"
              fill="#F8EC26"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="39"
            viewBox="0 0 29 39"
            fill="none"
            className="svg-background tablet"
          >
            <path
              d="M0.779541 0H29V39L2.47599 34.9272C1.50007 34.7773 0.779541 33.9377 0.779541 32.9503V0Z"
              fill="#F8EC26"
            />
          </svg>
          <span className="top-label">
            {getDynamicLabelValues('dynamic.browse_d.lbl_trending_in_category_badge_top_label')}
          </span>
          <span className="bottom-label">
            {getDynamicLabelValues('dynamic.browse_d.lbl_trending_in_category_badge_bottom_label')}
          </span>
        </div>
      )}
    </ImageContainer>
  );
};

const TrendingInCategoryTile = ({
  className,
  product,
  isHideOriginalPriceAndMarchantTagEnabled,
  isDynamicBadgeEnabled,
  currencySymbol,
  currencyAttributes,
  onQuickViewOpenClick,
  isTrendingInCategoryRecommendationsDisplayBadgeEnabled,
}) => {
  const { recToken, productInfo, colorsMap, imagesByColor, generalProductId } = product;
  const { basicImageUrl: imageUrl } = imagesByColor.SPRUCESHAD || {};
  const { miscInfo } = colorsMap[0];
  const { badge3 } = miscInfo;
  const {
    pdpUrl,
    ratings,
    reviewsCount,
    tcpStyleQty,
    tcpStyleType,
    primaryBrand,
    hardMarkDown,
    name,
    listPrice,
    offerPrice,
  } = productInfo;

  const isHideOriginalPrice = hideProductOriginalPrice(
    hardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled
  );

  const dynamicBadgeOverlayQty = getDynamicBadgeQty(
    tcpStyleType,
    tcpStyleQty,
    isDynamicBadgeEnabled
  );

  const pdpToPath = getProductListToPath(pdpUrl);

  const newPdpToPath =
    pdpToPath &&
    `${pdpToPath}&viaModule=${
      Constants.RECOMMENDATION
    }&viaPage=plp&dataSource=recommendation&recommendationCarousel=${getDynamicLabelValues(
      'dynamic.browse_d.lbl_trending_in_category_header'
    )}&recToken=${recToken}
  `;

  const handleClick = (colorProductId) => {
    requestAnimationFrame(() => {
      onQuickViewOpenClick({
        colorProductId,
        fromPage: 'plp',
      });
    });
  };

  return (
    <div className={`${className} trending-in-category-recommendation-tile`}>
      {renderImage({
        imageUrl,
        dynamicBadgeOverlayQty,
        pdpAsPath: pdpUrl,
        pdpToPath: newPdpToPath,
        name,
        tcpStyleType,
        primaryBrand,
        isTrendingInCategoryRecommendationsDisplayBadgeEnabled,
      })}
      {renderPriceSection({
        currencySymbol,
        currencyAttributes,
        listPrice,
        offerPrice,
        merchantTag: badge3,
        isHideOriginalPrice,
        name,
        handleClick,
        productId: generalProductId,
      })}
      {renderRatings({ ratings, reviewsCount })}
    </div>
  );
};

TrendingInCategoryTile.propTypes = {
  className: PropTypes.string,
  product: PropTypes.shape({}),
  isHideOriginalPriceAndMarchantTagEnabled: PropTypes.bool,
  isDynamicBadgeEnabled: PropTypes.shape({}),
  currencySymbol: PropTypes.string,
  currencyAttributes: PropTypes.shape({}),
  onQuickViewOpenClick: PropTypes.func.isRequired,
};

TrendingInCategoryTile.defaultProps = {
  className: '',
  product: {},
  isHideOriginalPriceAndMarchantTagEnabled: false,
  isDynamicBadgeEnabled: {},
  currencySymbol: '',
  currencyAttributes: {},
};

export default withStyles(TrendingInCategoryTile, styles);

export { TrendingInCategoryTile as TrendingInCategoryTileVanilla };
